import * as React from 'react'

interface INumberIncrementSelectorState {}

interface INumberIncrementSelectorProps {
  onChange?: (value: number) => void
  value: number
}

class NumberIncrementSelector extends React.Component<INumberIncrementSelectorProps, INumberIncrementSelectorState> {
  public render() {
    return (
      <div className='flex ml-auto'>
        <div
          className='user-select-none font-grey2 bold h3 icon--41x36 cursor--pointer bg-light-yellow rounded flex items-center justify-center'
          onClick={this.decrement}
        >
          -
        </div>
        <div className='user-select-none icon--41x36 flex items-center justify-center'>{this.props.value}</div>
        <div
          className='user-select-none font-grey2 bold h3 icon--41x36 cursor--pointer bg-light-yellow rounded flex items-center justify-center'
          onClick={this.increment}
        >
          +
        </div>
      </div>
    )
  }

  private increment = () => {
    if (this.props.onChange) {
      this.props.onChange(this.props.value + 1)
    }
  }

  private decrement = () => {
    if (!this.props.onChange || this.props.value <= 0) {
      return
    }
    this.props.onChange(this.props.value - 1)
  }
}

export default NumberIncrementSelector



// WEBPACK FOOTER //
// ./src/components/ui/NumberIncrementSelector.tsx